import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.assays'),
    id: 'generalAssays',
    sidebar: [
        {
            id: 'assaysGroups',
            label: i18n.tc('configuration.sections.assayGroup', 2),
            icon: 'fal fa-th-large',
            routeName: 'AssaysGroups',
            hasChildren: false
        },
        {
            id: 'assays',
            label: i18n.tc('configuration.sections.assay', 2),
            icon: 'fas fa-flask',
            routeName: 'Assays',
            hasChildren: false
        }
    ]
}
